import '@webcomponents/custom-elements'

const POWCLOUD_PROD_DOMAIN = `${window.location.protocol}//${window.location.host}`
// https://developers.google.com/web/fundamentals/web-components/shadowdom
export class Preview extends HTMLElement {
  code: any
  key: any
  testmode: any
  constructor(code, key, testmode) {
    super()
    this.code = code
    this.key = key
    this.testmode = testmode
  }

  // .formtopia-field {  }
  connectedCallback() {
    this.attachShadow({ mode: 'open' })

    const tpl = document.createElement('template')
    const copy = tpl.content.cloneNode(true)

    const formtopiaScript = document.createElement('script')
    formtopiaScript.setAttribute('type', 'module')
    formtopiaScript.setAttribute('src', `${POWCLOUD_PROD_DOMAIN}/formtopia/js/latest/formtopia-webcomponent.mjs`)

    const bootstrapStyles = document.createElement('link')
    bootstrapStyles.rel = 'stylesheet'
    bootstrapStyles.href = 'https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css'

    const bootstrapJS = document.createElement('script')
    bootstrapJS.src = 'https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/js/bootstrap.bundle.min.js'

    copy.appendChild(bootstrapStyles)
    copy.appendChild(bootstrapJS)
    copy.appendChild(formtopiaScript)

    const innerHTML = `
<!-- 
${this.code} 
-->`

    let formtopiaWC = document.createElement('formtopia-form')
    formtopiaWC.setAttribute('key', this.key)
    formtopiaWC.setAttribute('flavor', 'bootstrap')
    formtopiaWC.setAttribute('testmode', this.testmode)
    formtopiaWC.setAttribute('endpoint', POWCLOUD_PROD_DOMAIN)

    formtopiaWC.innerHTML = innerHTML

    copy.appendChild(formtopiaWC)

    this.shadowRoot.appendChild(copy)
  }
}
customElements.define('form-preview', Preview)
